import { twMerge } from "tailwind-merge"

export const AdditionalPriceIndicator = (props) => {
  return (
    <div class={twMerge(
      "bg-primary-100 border border-solid border-ink flex py-1 rounded-xl text-2xs",
      props.class ?? ""
    )}>
      <div class="flex flex-1 justify-between px-1">
        <div>{props.label}</div>
        <div>{props.price}</div>
      </div>
      <button
        type="button"
        class="px-1 border-l border-ink underline underline-offset-4 hover:no-underline"
        onClick={props.onClear}
      >Clear</button>
    </div>
  )
}